export {default as Postpaid} from './postpaid'